import { uid } from 'radash'

function addQueryParams (params) {
  const url = new URL(window.location.href)

  Object.keys(params).forEach(key => {
    url.searchParams.set(key, params[key])
  })
  window.history.replaceState(null, '', url.toString())
}

function clearQueryParams () {
  window.history.replaceState(null, '', window.location.pathname)
}

async function playSound (type, tryToReplay = true, extension = 'wav') {
  try {
    const audio = new Audio(`/sound/${type}.${extension}`)

    if (extension === 'mp3') {
      audio.volume = .5
    } else {
      audio.volume = .4
    }

    await audio.play()
  } catch (error) {
    if (error?.message.includes('didn\'t interact')) {
      console.log('User didn\'t interact with the document first. Cannot play sound.')

      if (tryToReplay) {
        localStorage.setItem('sound-anchor', `${type}-${uid(6)}`)
      }
    }
  }
}

export {
  addQueryParams,
  clearQueryParams,
  playSound
}